import {Employee} from "../domain/entities/employee.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

export class CreateEmployeeCommand extends AbstractCommand<Employee> {

    public name: CommandName = CommandName.CREATE_EMPLOYEE;

    public tags = ['entity', 'create', 'employee'];

    constructor(employee: Employee) {
        super('employee', employee.uid, employee);
    }
}